import React from "react";
import { connect } from "react-redux";
import HelmetTickets from "./HelmetTickets";

import TicketHeader from "./TicketHeader";
import TicketNumbers from "./TicketNumbers";
import TicketBody from "./TicketBody";
import Results from "./Result/Ticket/Results";
import ResultsError from "./Result/Errors/ResultsError";
import NotFound from "../../errorPages/NotFound";
import useWindowDimensions from "../../WindowDimensions-hook/useWindowDimensions";
import { MOBILE_WIDTH } from "../../constants/otherConstants";

const Ticket = (props) => {
  const { width } = useWindowDimensions();
  let currentTask;
  let currentTaskExamIndex;
  let paramsTaskId = props.paramsTaskId;
  let notToRenderTimer;
  if (
    props.categoryTickets === "errorsAB" ||
    props.categoryTickets === "errorsCD" ||
    props.categoryTickets === "themeAB" ||
    props.categoryTickets === "themeCD" ||
    props.categoryTickets === "newAB" ||
    props.categoryTickets === "newCD"
  )
    notToRenderTimer = true;

  if (
    props.categoryTickets === "examAB" ||
    props.categoryTickets === "examCD" ||
    props.categoryTickets === "newAB" ||
    props.categoryTickets === "newCD"
  ) {
    paramsTaskId = props.examParamsTaskId;
    currentTask = props.currentTicket.tasks.find(
      (task, index) => index === parseInt(paramsTaskId) - 1
    );

    currentTaskExamIndex = props.currentTicket.tasks.findIndex(
      (task, index) => index === parseInt(paramsTaskId) - 1
    );
  } else {
    currentTask = props.currentTicket.tasks.find(
      (task) => task.taskId === props.paramsTaskId
    );
  }

  //Возможно это if лишний
  /*  console.log(currentTask) */
  if (
    !currentTask &&
    (props.categoryTickets === "errorsAB" ||
      props.categoryTickets === "errorsCD")
  ) {
    const errorsArray = JSON.parse(localStorage.getItem("errorsArray"));
    if (errorsArray) {
      const check = errorsArray.filter((el) => el.ticketErrors.length !== 0);
      if (check.length === 0) {
        localStorage.removeItem("errorsArray");
      }
    }
  }
  /*  console.log(props.currentTicket.tasks.length,"props.currentTicket.tasks.length")
   console.log(props.numbersStateArray.length, "props.numbersStateArray.length") */


  if (!currentTask) return <NotFound />;
  else
    return (
      <div>
        <HelmetTickets
          categoryTickets={props.categoryTickets}
          currentTicket={props.currentTicket}
          paramsTaskId={paramsTaskId}
          currentTask={currentTask}
        />
        {props.currentTicket.tasks.length !== props.numbersStateArray.length ? (
          <div className="shared-card">

            {width > MOBILE_WIDTH &&
              <TicketHeader
                currentTicketHeader={props.currentTicket.header}
                notToRenderTimer={notToRenderTimer}
                categoryTickets={props.categoryTickets}
                timerColor="black"
              />}

            <TicketNumbers
              categoryTickets={props.categoryTickets}
              tasks={props.currentTicket.tasks}
              paramsTaskId={paramsTaskId}
              ticketId={props.currentTicket.ticketId}
            />

            <TicketBody
              categoryTickets={props.categoryTickets}
              tasks={props.currentTicket.tasks}
              img={currentTask.img}
              question={currentTask.question}
              answers={currentTask.answers}
              hint={currentTask.hint}
              rightAnswer={currentTask.rightAnswer}
              paramsTaskId={paramsTaskId}
              ticketId={props.currentTicket.ticketId}
              taskId={currentTask.taskId}
              examTicketId={currentTask.ticketId}
              currentTaskExamIndex={currentTaskExamIndex}
              // realTaskId, themeTicketId используется только в режиме тем.
              themeTicketId={currentTask.ticketId}
              realTaskId={currentTask.realTaskId}
            />
          </div>
        ) : props.categoryTickets === "errorsAB" ||
          props.categoryTickets === "errorsCD" ? (
          <ResultsError
            currentTicketHeader={props.currentTicket.header}
            currentTicket={props.currentTicket}
            finalResultArray={props.numbersStateArray}
            ticketsArray={props.ticketsArray}
            categoryTickets={props.categoryTickets}
          />
        ) : (
          <Results
            categoryTickets={props.categoryTickets}
            currentTicketHeader={props.currentTicket.header}
            currentTicket={props.currentTicket}
            finalResultArray={props.numbersStateArray}
            ticketsArray={props.ticketsArray}
          />
        )}
      </div>
    );
};

const mapStateToProps = (state) => {
  return {
    examParamsTaskId: state.router.location.pathname.split("/")[2],
    paramsTaskId: state.router.location.pathname.split("/")[3],
    numbersStateArray: state.ticketsReducer.numbersStateArray,
  };
};

export default connect(mapStateToProps, null)(Ticket);
